import { render, staticRenderFns } from "./batch-event-details.vue?vue&type=template&id=b2a8a484&"
import script from "./batch-event-details.vue?vue&type=script&lang=ts&"
export * from "./batch-event-details.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports